import React, { lazy, FC, Suspense, useState, useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { RootState } from "../../setup";
import TopBarProgress from "react-topbar-progress-indicator";

import { getCSSVariableValue } from "../../_jutemplate/assets/ts/_utils";
import { MasterLayout } from "../../_jutemplate/layout/MasterLayout";

//redux
import { shallowEqual, useSelector } from "react-redux";

//component
import { DashboardPage } from "../modules/dashboard/DashboardPage";

const PrivateRoutes = () => {
  const [islogin, setIslogin] = useState<any>({});

  const UserProfileRootPage = lazy(
    () => import("../modules/user-profile/pages/UserProfileRootPage")
  );
  const EmployeeRootPage = lazy(
    () => import("../modules/employee/pages/EmployeeRootPage")
  );
  const HelpLineRootPage = lazy(
    () => import("../modules/help-line/pages/HelpLineRootPage")
  );
  const TrainingMaterialRootPage = lazy(
    () => import("../modules/training-material/pages/TrainingMaterialRootPage")
  );

  // reserve-bunch
  const RBMyFarmerRootPage = lazy(
    () => import("../modules/reserve-bunch/my-farmer/pages/MyFarmerRootPage")
  );

  const RBAggregatorFarmerRootPage = lazy(
    () =>
      import(
        "../modules/reserve-bunch/aggregator-farmer/pages/AggregatorFarmerRootPage"
      )
  );

  //supplier
  const PendingFarmersRootPages = lazy(
    () =>
      import(
        "../modules/supplier/pending-farmers/pages/PendingFarmersRootPages"
      )
  );

  const MyFarmersRootPage = lazy(
    () => import("../modules/supplier/my-farmers/pages/MyFarmersRootPage")
  );

  const MyAggregatorsRootPage = lazy(
    () =>
      import("../modules/supplier/my-aggregators/pages/MyAggregatorsRootPage")
  );

  const AggregatorsFarmersRootPage = lazy(
    () =>
      import(
        "../modules/supplier/aggregators-farmers/pages/AggregatorsFarmersRootPage"
      )
  );

  //customer

  const CustomerRootPage = lazy(
    () => import("../modules/customer/customer/pages/CustomerRootPage")
  );

  const OrderRootPage = lazy(
    () => import("../modules/customer/order/pages/OrderRootPage")
  );

  //inventory
  const StockRootPage = lazy(
    () => import("../modules/inventory/stock/pages/StockRootPage")
  );

  const StockChamberRootPage = lazy(
    () =>
      import("../modules/inventory/stock-chamber/pages/StockChamberRootPage")
  );

  const StockVarityRootPage = lazy(
    () => import("../modules/inventory/stock-variety/pages/StockVarityRootPage")
  );

  const StockGradingRootPage = lazy(
    () =>
      import("../modules/inventory/stock-grading/pages/StockGradingRootPage")
  );

  const StockPendingRootPage = lazy(
    () =>
      import("../modules/inventory/stock-pending/pages/StockPendingRootPage")
  );

  const StockReportRootPage = lazy(
    () => import("../modules/report/stock-report/pages/StockReportRootPage")
  );

  const DayWiseWastageReportRootPage = lazy(
    () =>
      import(
        "../modules/report/day-wise-wastage-report/pages/DayWiseWastageReportRootPage"
      )
  );

  const CustomerWiseReturnReportRootPages = lazy(
    () =>
      import(
        "../modules/report/customer-wise-return-report/pages/CustomerWiseReturnReportRootPages"
      )
  );

  const CustomerWiseSalesRootPage = lazy(
    () =>
      import(
        "../modules/report/customer-wise-sales-report/pages/CustomerWiseSalesRootPage"
      )
  );

  //reports

  // const AnalyticsReportingPage = lazy(
  //   () => import("../modules/reports/analytics-reporting/AnalyticsReportingPage")
  // );

  // const ReportDemandForecastPage = lazy(
  //   () => import("../modules/reports/demand-forecast/DemandForecastPage")
  // );
  // const SalesPlansPage = lazy(
  //   () => import("../modules/reports/sales-plans//SalesPlansPage")
  // );

  //settings
  const BananaTypeRootPage = lazy(
    () => import("../modules/settings/banana-types/pages/BananaTypeRootPage")
  );
  const DesignationRootPage = lazy(
    () => import("../modules/settings/designation/pages/DesignationRootPage")
  );

  const UnwantedDamageTypeRootPage = lazy(
    () =>
      import(
        "../modules/settings/unwanted-damage-type.tsx/pages/UnwantedDamageTypeRootPage"
      )
  );

  const DistrictRootPage = lazy(
    () => import("../modules/settings/district/pages/DistrictRootPage")
  );

  const CustomerTypeRootPage = lazy(
    () => import("../modules/settings/customer-type/pages/CustomerTypeRootPage")
  );

  const ChamberRootPage = lazy(
    () => import("../modules/settings/chamber/pages/ChamberRootPage")
  );

  const SupplyBananaTypeRootPage = lazy(
    () =>
      import(
        "../modules/settings/supply-banana-type/pages/SupplyBananaTypeRootPage"
      )
  );

  const LandPreparationRootPage = lazy(
    () =>
      import(
        "../modules/settings/land-preparation/pages/LandPreparationRootPage"
      )
  );

  const PermissionRootPage = lazy(
    () => import("../modules/settings/permission/pages/PermissionRootPage")
  );

  const ModuleRootPage = lazy(
    () => import("../modules/settings/module/pages/ModuleRootPage")
  );

  const RoleManagementRootPage = lazy(
    () =>
      import("../modules/settings/role-management/pages/RoleManagementRootPage")
  );

  const PesticideRootPage = lazy(
    () => import("../modules/settings/pesticides/pages/PesticideRootPage")
  );

  const FertilizerRootPage = lazy(
    () => import("../modules/settings/fertilizer/pages/FertilizerRootPage")
  );

  // const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  // const DataTableWrapper = lazy(() => import('../pages/data-table/dataTableWrapper'))
  // const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  // const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  // const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  // const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  // const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  // const Users  = lazy(()=> import("../modules/users/UserPage"))

  /////////////////

  const isAuthorized: any = useSelector<RootState>(
    ({ auth }) => auth.user,
    shallowEqual
  );
  console.log(isAuthorized);

  // useEffect(() => {
  //   if (isAuthorized) {
  //     console.log(isAuthorized)
  //     setIslogin(isAuthorized)
  //   }
  // }, [isAuthorized])

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path="auth/*" element={<Navigate to="/dashboard" />} />
        <Route path="dashboard" element={<DashboardPage />} />

        {/* Others rute Pages */}

        <Route
          path="/user/*"
          element={
            <SuspensedView>
              <UserProfileRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/employee/*"
          element={
            <SuspensedView>
              <EmployeeRootPage />
            </SuspensedView>
          }
        />

        {/*  start banana calendar */}
        <Route
          path="/reserve-bunch/my-farmers/*"
          element={
            <SuspensedView>
              <RBMyFarmerRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/reserve-bunch/aggregators-farmers/*"
          element={
            <SuspensedView>
              <RBAggregatorFarmerRootPage />
            </SuspensedView>
          }
        />

        {/* end banana calendar */}

        {/*  start supplier */}

        <Route
          path="/supplier/pending-farmers/*"
          element={
            <SuspensedView>
              <PendingFarmersRootPages />
            </SuspensedView>
          }
        />

        <Route
          path="/supplier/my-farmers/*"
          element={
            <SuspensedView>
              <MyFarmersRootPage />
            </SuspensedView>
          }
        />
        <Route
          path="/supplier/my-aggregators/*"
          element={
            <SuspensedView>
              <MyAggregatorsRootPage />
            </SuspensedView>
          }
        />
        <Route
          path="/supplier/aggregators-farmers/*"
          element={
            <SuspensedView>
              <AggregatorsFarmersRootPage />
            </SuspensedView>
          }
        />
        {/* end supplier */}

        {/*  start customer */}
        <Route
          path="/customer/customer-list/*"
          element={
            <SuspensedView>
              <CustomerRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/customer/order/*"
          element={
            <SuspensedView>
              <OrderRootPage />
            </SuspensedView>
          }
        />

        {/* end customer */}

        {/*  start inventory */}
        <Route
          path="/inventory/stock/*"
          element={
            <SuspensedView>
              <StockRootPage />
            </SuspensedView>
          }
        />
        <Route
          path="/inventory/stock-chamber/*"
          element={
            <SuspensedView>
              <StockChamberRootPage />
            </SuspensedView>
          }
        />
        <Route
          path="/inventory/stock-variety/*"
          element={
            <SuspensedView>
              <StockVarityRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/inventory/stock-grading/*"
          element={
            <SuspensedView>
              <StockGradingRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/inventory/stock-approval/*"
          element={
            <SuspensedView>
              <StockPendingRootPage />
            </SuspensedView>
          }
        />

      {/* end inventory*/}
     
      {/* start report */}
        <Route
          path="/report/day-wise-sells-report/*"
          element={
            <SuspensedView>
              <StockReportRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/report/day-wise-wastage-report/*"
          element={
            <SuspensedView>
              <DayWiseWastageReportRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/report/enterprise-wise-return-report/*"
          element={
            <SuspensedView>
              <CustomerWiseReturnReportRootPages />
            </SuspensedView>
          }
        />

        <Route
          path="/report/enterprise-wise-sales-report/*"
          element={
            <SuspensedView>
              <CustomerWiseSalesRootPage />
            </SuspensedView>
          }
        />
        {/* end report */}
       



        <Route
          path="/training-material/*"
          element={
            <SuspensedView>
              <TrainingMaterialRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/help-line/*"
          element={
            <SuspensedView>
              <HelpLineRootPage />
            </SuspensedView>
          }
        />

        {/*  start setting */}
        <Route
          path="/settings/banana-types/*"
          element={
            <SuspensedView>
              <BananaTypeRootPage />
            </SuspensedView>
          }
        />
        <Route
          path="/settings/designation/*"
          element={
            <SuspensedView>
              <DesignationRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/settings/damage-type/*"
          element={
            <SuspensedView>
              <UnwantedDamageTypeRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/settings/district/*"
          element={
            <SuspensedView>
              <DistrictRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/settings/customer-type/*"
          element={
            <SuspensedView>
              <CustomerTypeRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/settings/chamber/*"
          element={
            <SuspensedView>
              <ChamberRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/settings/supply-banana-type/*"
          element={
            <SuspensedView>
              <SupplyBananaTypeRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/settings/land-preparation/*"
          element={
            <SuspensedView>
              <LandPreparationRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/settings/access-permission/*"
          element={
            <SuspensedView>
              <PermissionRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/settings/module/*"
          element={
            <SuspensedView>
              <ModuleRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/settings/role-management/*"
          element={
            <SuspensedView>
              <RoleManagementRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/settings/pesticide/*"
          element={
            <SuspensedView>
              <PesticideRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/settings/fertilizer/*"
          element={
            <SuspensedView>
              <FertilizerRootPage />
            </SuspensedView>
          }
        />

        {/* end setting */}

        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Route>
    </Routes>
  );
};

const SuspensedView: FC<{ children: React.ReactNode }> = ({ children }) => {
  const baseColor = getCSSVariableValue("--bs-primary");
  TopBarProgress.config({
    barColors: {
      "0": baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };
